import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { NavigationMenuItem } from "#ui/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentationSidebar',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const { data: categories } = (
  ([__temp,__restore] = _withAsyncContext(() => useDocumentationCategories())),
  __temp = await __temp,
  __restore(),
  __temp
);

// Find which category contains the current article
const activeCategory = computed(() => {
  const currentSlug = route.params.slug as string;
  if (!currentSlug || !categories.value) return null;

  return categories.value.find((cat) =>
    cat.articles?.some((article) => article.slug.current === currentSlug),
  );
});

// Transform categories and articles into NavigationMenuItem format
const navigationItems = computed<NavigationMenuItem[]>(() => {
  if (!categories.value) return [];

  return categories.value.map((category) => {
    const children: NavigationMenuItem[] =
      category.articles?.map((article) => ({
        label: article.title,
        to: `/help/${article.slug.current}`,
      })) || [];

    // Determine if this category should be open by default
    // Open if it contains the active article
    const defaultOpen = activeCategory.value?._id === category._id;

    return {
      label: category.title,
      icon: category.icon || "i-heroicons-folder",
      defaultOpen,
      children: children.length > 0 ? children : undefined,
    };
  });
});

return (_ctx: any,_cache: any) => {
  const _component_UNavigationMenu = _resolveComponent("UNavigationMenu")!

  return (_openBlock(), _createBlock(_component_UNavigationMenu, {
    items: _unref(navigationItems),
    orientation: "vertical",
    color: "neutral",
    variant: "link",
    highlight: "",
    "highlight-color": "neutral"
  }, null, 8, ["items"]))
}
}

})